import React from 'react'
import PropTypes from 'prop-types'

import ContentHolder from '../../ui/ContentHolder'
import Review from './Review'
import styles from './styles.scss'

const Reviews = (props) => {
  const { campaigns, reviews } = props

  return (
    <div className={styles.root}>
      <ContentHolder>
        <div className={styles.reviewHolder}>
          {reviews.map((review) => {
            const campaign = campaigns[review.subject_id] || {}
            return (
              <Review key={review.id} campaign={campaign} review={review} />
            )
          })}
        </div>
      </ContentHolder>
    </div>
  )
}

Reviews.propTypes = {
  campaigns: PropTypes.object.isRequired,
  reviews: PropTypes.array.isRequired,
}

export default Reviews
